(() => {
  const money = (cents) => {
    const amount = (Number(cents || 0) / 100).toFixed(2);
    const format = window.VestaTheme?.moneyFormat || '${{amount}}';
    return format
      .replace('{{amount}}', amount.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace('{{ amount }}', amount.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace('{{amount_no_decimals}}', Math.round(Number(cents || 0) / 100).toString())
      .replace('{{ amount_no_decimals }}', Math.round(Number(cents || 0) / 100).toString());
  };

  const root = () => window.VestaTheme?.root || '/';
  const cartEndpoint = () => `${root()}cart.js`;
  const addEndpoint = () => `${root()}cart/add.js`;
  const changeEndpoint = () => `${root()}cart/change.js`;

  const drawer = document.querySelector('[data-cart-drawer]');
  const backdrop = document.querySelector('[data-cart-backdrop]');
  const drawerBody = document.querySelector('[data-cart-drawer-body]');
  const drawerTotal = document.querySelector('[data-cart-drawer-total]');

  function setDrawer(open) {
    if (!drawer || !backdrop) return;
    drawer.classList.toggle('is-open', open);
    backdrop.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('drawer-open', open);
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    if (!drawerBody) return;
    if (!cart.items.length) {
      drawerBody.innerHTML = '<div class="drawer-empty"><p>Your cart is empty.</p><a class="button" href="/collections/all">Shop pieces</a></div>';
      if (drawerTotal) drawerTotal.textContent = money(0);
      return;
    }
    drawerBody.innerHTML = cart.items.map((item, index) => `
      <div class="drawer-line">
        <a href="${item.url}">${item.image ? `<img src="${item.image}" alt="">` : '<div class="placeholder-media" style="width:72px;aspect-ratio:4/5"></div>'}</a>
        <div>
          <a href="${item.url}"><strong>${item.product_title}</strong></a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="micro muted" style="margin-top:4px">${item.variant_title}</div>` : ''}
          <div class="mono" style="font-size:12px;margin-top:8px">${item.quantity} × ${money(item.final_price)}</div>
        </div>
        <button class="drawer-line__remove" type="button" data-cart-remove="${index + 1}">Remove</button>
      </div>
    `).join('');
    if (drawerTotal) drawerTotal.textContent = money(cart.total_price);
  }

  async function refreshCart(open = false) {
    try {
      const res = await fetch(cartEndpoint(), { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      renderCart(cart);
      if (open) setDrawer(true);
    } catch (e) { console.error(e); }
  }

  document.addEventListener('click', async (event) => {
    const openBtn = event.target.closest('[data-cart-open]');
    if (openBtn) { event.preventDefault(); await refreshCart(true); return; }
    if (event.target.closest('[data-cart-close]') || event.target === backdrop) { setDrawer(false); return; }

    const removeBtn = event.target.closest('[data-cart-remove]');
    if (removeBtn) {
      removeBtn.disabled = true;
      try {
        const res = await fetch(changeEndpoint(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(removeBtn.dataset.cartRemove), quantity: 0 })
        });
        renderCart(await res.json());
      } catch (e) { console.error(e); }
      return;
    }

    const mobileOpen = event.target.closest('[data-mobile-open]');
    const mobileClose = event.target.closest('[data-mobile-close]');
    const mobile = document.querySelector('[data-mobile-menu]');
    if (mobileOpen && mobile) { mobile.classList.add('is-open'); document.body.classList.add('menu-open'); }
    if (mobileClose && mobile) { mobile.classList.remove('is-open'); document.body.classList.remove('menu-open'); }

    const thumb = event.target.closest('[data-product-thumb]');
    if (thumb) {
      const main = document.querySelector('[data-product-main-image]');
      if (main) {
        main.src = thumb.dataset.src;
        if (thumb.dataset.srcset) main.srcset = thumb.dataset.srcset;
        main.alt = thumb.dataset.alt || '';
      }
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form.product-form, form[data-product-form]');
    if (!form) return;
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    const oldText = submit?.textContent;
    if (submit) { submit.disabled = true; submit.textContent = 'Adding…'; }
    try {
      const res = await fetch(addEndpoint(), { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!res.ok) throw new Error((await res.json()).description || 'Could not add item');
      await refreshCart(true);
    } catch (e) {
      const msg = form.querySelector('[data-product-form-message]');
      if (msg) msg.textContent = e.message;
    } finally {
      if (submit) { submit.disabled = false; submit.textContent = oldText; }
    }
  });


  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const price = document.querySelector('[data-product-price]');
      if (price && option?.dataset.priceText) price.textContent = option.dataset.priceText;
    });
  });

  document.querySelectorAll('[data-fit-builder]').forEach((builder) => {
    const totalEl = builder.querySelector('[data-fit-total]');
    const message = builder.querySelector('[data-fit-message]');
    const add = builder.querySelector('[data-fit-add]');
    const selects = [...builder.querySelectorAll('[data-fit-select]')];
    const discount = Number(builder.dataset.discount || 0);

    const recalc = () => {
      const total = selects.reduce((sum, s) => {
        const opt = s.options[s.selectedIndex];
        return sum + Number(opt?.dataset.price || 0);
      }, 0);
      const final = Math.round(total * (1 - discount / 100));
      if (totalEl) totalEl.textContent = money(final);
    };
    selects.forEach((s) => s.addEventListener('change', recalc));
    recalc();

    add?.addEventListener('click', async () => {
      const items = selects.filter((s) => s.value).map((s) => ({ id: Number(s.value), quantity: 1 }));
      if (!items.length) { if (message) message.textContent = 'Choose at least one piece.'; return; }
      add.disabled = true; if (message) message.textContent = 'Adding your fit…';
      try {
        const res = await fetch(addEndpoint(), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!res.ok) throw new Error((await res.json()).description || 'Could not add fit');
        if (message) message.textContent = 'Fit added.';
        await refreshCart(true);
      } catch (e) { if (message) message.textContent = e.message; }
      finally { add.disabled = false; }
    });
  });

  document.querySelectorAll('[data-email-popup-wrap]').forEach((wrap) => {
    const popup = wrap.querySelector('[data-email-popup]');
    if (!popup) return;
    const key = `vesta-popup-${wrap.dataset.sectionId}`;
    const delay = Number(wrap.dataset.delay || 6) * 1000;
    const open = () => { if (!localStorage.getItem(key)) popup.classList.add('is-open'); };
    const close = () => { popup.classList.remove('is-open'); localStorage.setItem(key, 'closed'); };
    setTimeout(open, delay);
    popup.querySelectorAll('[data-popup-close]').forEach((b) => b.addEventListener('click', close));
    const form = popup.querySelector('form');
    form?.addEventListener('submit', () => localStorage.setItem(key, 'submitted'));
  });

  refreshCart(false);
})();
